import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Fab,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { RepresentativeFormType } from "../../types/entitiesModel";
import { ERROR_MESSAGE, OK_MESSAGE } from "../../utils/Constants";
import { CheckCircleOutline } from "@mui/icons-material";
import { messageType } from "../../types/otherTypes";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { AuthContext } from "../../context/AuthContext";


const EditRepresentative: React.FC = () => {
  const { token } = React.useContext(AuthContext) || {};
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [formState, setFormState] = React.useState<RepresentativeFormType>({
    name: "",
    document: "",
    relationship: "",
    phone: "",
    email: "",
  });

  const [message, setMessage] = React.useState<messageType>({
    message: "",
    type: OK_MESSAGE, // can change
  });

  /**
   * To handle form data
   *
   * @param event
   */
  const handleChangeForm = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBackView = () => {
    navigate("/admin/representatives");
  };

  /**
   * Send data to api, to save the category
   */
  const handleSubmit = async () => {
    const requestBody = {
      name: formState.name,
      document: formState.document,
      relationship: formState.relationship,
      phone: formState.phone,
      email: formState.email,
    };

    try {
      const response = await fetch(`/api/representatives/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const responseData = await response.json();

        setMessage({
          message: `Success: ${
            responseData.messages || "Data enviada con éxito"
          }`,
          type: OK_MESSAGE,
        });

        setTimeout(() => {
          navigate("/admin/representatives");
        }, 1000);
      } else {
        const errorData = await response.json();
        setMessage({
          message: `Error: ${errorData.message || "Algo ha ido mal"}`,
          type: ERROR_MESSAGE,
        });
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        setMessage({
          message: `Error: ${
            error.message || "Ha ocurrido un error inesperado"
          }`,
          type: ERROR_MESSAGE,
        });
      } else {
        setMessage({
          message: "Error: Error desconocido",
          type: ERROR_MESSAGE,
        });
      }
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0}>
        {message.message !== "" &&
          (message.type === OK_MESSAGE ? (
            <Alert
              icon={<CheckCircleOutline fontSize="inherit" />}
              severity="success"
              sx={{
                mx: "auto",
                mb: 2,
                width: "95%",
              }}
            >
              {message.message}
            </Alert>
          ) : (
            <Alert
              sx={{
                m: "auto",
                mb: 2,
                width: "95%",
              }}
              severity="error"
            >
              {message.message}
            </Alert>
          ))}
        <Fab
          color="primary"
          variant="extended"
          sx={{
            mr: 1,
            mb: {
              xs: 1,
              sm: 0,
              lg: 0,
            },
            ml: 2,
          }}
          onClick={handleBackView}
        >
          <KeyboardDoubleArrowLeftIcon />
          <Typography
            sx={{
              ml: 1,
              textTransform: "capitalize",
            }}
          >
            {"Tabla de representantes"}
          </Typography>
        </Fab>
        <Grid item lg={12} md={12} xs={12}>
          <div>
            <Card
              variant="outlined"
              sx={{
                p: 0,
              }}
            >
              <Box
                sx={{
                  padding: "15px 30px",
                }}
                display="flex"
                alignItems="center"
              >
                <Box flexGrow={1}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    Edición del representante {id}
                  </Typography>
                </Box>
              </Box>
              <Divider />
              <CardContent
                sx={{
                  padding: "30px",
                }}
              >
                <form>
                  {/* Nombre  y Documento */}
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <TextField
                        id="name"
                        label="Nombre"
                        variant="outlined"
                        placeholder="Nombre"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="name"
                        onChange={handleChangeForm}
                      />
                      <TextField
                        id="document"
                        label="Documento"
                        type="text"
                        variant="outlined"
                        placeholder="Documento"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="document"
                        onChange={handleChangeForm}
                      />
                      <TextField
                        id="email"
                        label="Email"
                        type="text"
                        variant="outlined"
                        placeholder="Email"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="email"
                        onChange={handleChangeForm}
                      />
                    </Grid>
                    {/* Relación y teléfono */}
                    <Grid item md={6} xs={12}>
                      <TextField
                        id="relationship"
                        label="Relación con estudiante"
                        type="text"
                        variant="outlined"
                        placeholder="Relación con estudiante"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="relationship"
                        onChange={handleChangeForm}
                      />
                      <TextField
                        id="phone"
                        label="Teléfono"
                        type="text"
                        variant="outlined"
                        placeholder="Teléfono"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="phone"
                        onChange={handleChangeForm}
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Button
                      onClick={() => {
                        handleSubmit();
                      }}
                      color="primary"
                      variant="contained"
                    >
                      Enviar
                    </Button>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default EditRepresentative;
